var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#00000064",
    width: "64px",
    height: "64px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.815,7.8H9.6a1.8,1.8,0,0,1,0,3.6H4.814a1.8,1.8,0,0,1,0-3.6Zm2.993-3a1.8,1.8,0,0,0,1.8,1.8h1.8V4.8a1.8,1.8,0,1,0-3.594,0Zm11.377,3a1.8,1.8,0,0,0-1.8,1.8v1.8h1.8a1.8,1.8,0,0,0,0-3.6ZM16.192,9.6V4.8a1.8,1.8,0,1,0-3.593,0V9.6a1.8,1.8,0,1,0,3.593,0Zm4.79,4.8a1.8,1.8,0,0,0-1.8-1.8H14.4a1.8,1.8,0,0,0,0,3.6h4.79A1.8,1.8,0,0,0,20.982,14.4Zm-8.384,3v1.8a1.8,1.8,0,1,0,1.8-1.8Zm-4.79-3v4.8a1.8,1.8,0,1,0,3.593,0V14.4a1.8,1.8,0,1,0-3.593,0Zm-4.79,0a1.8,1.8,0,1,0,3.593,0V12.6h-1.8A1.8,1.8,0,0,0,3.018,14.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrands);
export default __webpack_public_path__ + "static/media/brands.dffa166cd49ec9b776306107688b795c.svg";
export { ForwardRef as ReactComponent };